// Mirrors FleetHd.Issue ActivityEntryDto — one row in the Issue's append-only
// activity feed (lifecycle change, assignment, disposition, note add/delete,
// reopen). `initiatedBy` distinguishes automated (System), operator (User), and
// external/DVIR-driven (External) entries; `userId` is the real user for User
// entries and the "system" sentinel otherwise.

export const ActivityKinds = {
  LifecycleChanged: 'LifecycleChanged',
  Assigned: 'Assigned',
  Unassigned: 'Unassigned',
  DispositionSet: 'DispositionSet',
  NoteAdded: 'NoteAdded',
  NoteDeleted: 'NoteDeleted',
  Reopened: 'Reopened',
  ClearReceived: 'ClearReceived',
  ClearCanceled: 'ClearCanceled',
  // An operator report that merged into an already-open Issue. A merge changes no
  // lifecycle state, so this row is the feed's only record that it happened.
  ReportAdded: 'ReportAdded',
  // The live evidence changed the description. `fromValue` is the old text, `toValue` the new.
  DescriptionChanged: 'DescriptionChanged',
} as const;
export type ActivityKind = typeof ActivityKinds[keyof typeof ActivityKinds];

export type InitiatedByType = 'System' | 'User' | 'External';

export interface ActivityEntryDto {
  id: string;
  kind: ActivityKind | string;
  initiatedBy: InitiatedByType | string;
  userId: string;          // real user id when initiatedBy=User; "system" otherwise
  occurredAtDateTimeUtc: string;
  fromValue: string;       // lifecycle from-state / prior assignee
  toValue: string;         // lifecycle to-state / new assignee / disposition type
  // What the entry is about: the reported contribution's id on an operator-report
  // row (create / ReportAdded / reopen), noteId for note add/delete, else empty.
  targetId: string;
  reason: string;
}
